import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const SettingsAPI = {
  getSettings: async (token) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/settings`,
      headers: { Authorization: token },
    });
  },
  saveSettings: async (
    token,
    guestAccessDuration,
    residentialName,
    residentialAddress,
    residentialGeoPos
  ) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/settings`,
      headers: { Authorization: token },
      data: {
        guestAccessDuration,
        residentialName,
        residentialAddress,
        residentialGeoPos,
      },
    });
  },
};

export default SettingsAPI;
